import form from './form';
import personalForm from './personalForm';
import table from './table';

export default {
  layout: 'peer-reference-layout',
  form,
  personalForm,
  table,
};
